import { useApiClient } from "../../api-client";
import { useLang } from "../../i18n";

export const useAcceptAgreements = () => {
  const { post } = useApiClient();
  const lang = useLang();

  const acceptAgreements = () =>
    post(`/v1/employees/accept-agreements?lang=${lang}`);

  return {
    acceptAgreements,
  };
};
